/** 약관 문서 · 가입 동의 화면 문구 (DEV-07r · D97). 로그인 없이 읽힘 */
import { api } from './client.js';

/** @param {'terms'|'privacy'|'ai'} key */
export function fetchLegalDoc(key, { signal } = {}) {
    return api(`/legal/${key}`, { signal });
}

export function fetchConsentScreen({ signal } = {}) {
    return api('/legal/consent', { signal });
}
